export const getPermissionModule = (permissionKey, permissions) => {
  return permissions?.find((permission) => {
    if (permission?.key === permissionKey) return true;
    return permission?.submodules?.includes(permissionKey);
  });
};

export const hasPermissionByKey = (permissionKey, permissions) => {
  return Boolean(getPermissionModule(permissionKey, permissions));
};

/** The backend resolves CRM access from the Salesforce flag and the tier toggle; the app reads one boolean. */
export const canShowCrmNav = (crmAccessEnabled) => crmAccessEnabled === true;
